import { TicketStatus } from '@outlaw-oasis/types';

interface TicketStatusBadgeProps {
  status: TicketStatus;
  size?: 'sm' | 'md';
}

const statusConfig: Record<TicketStatus, { label: string; className: string }> = {
  open: {
    label: 'Open',
    className: 'bg-green-500/20 text-green-400',
  },
  in_progress: {
    label: 'In Progress',
    className: 'bg-blue-500/20 text-blue-400',
  },
  waiting_customer: {
    label: 'Waiting for Reply',
    className: 'bg-yellow-500/20 text-yellow-400',
  },
  resolved: {
    label: 'Resolved',
    className: 'bg-purple-500/20 text-purple-400',
  },
  closed: {
    label: 'Closed',
    className: 'bg-gray-500/20 text-gray-400',
  },
};

export function TicketStatusBadge({ status, size = 'md' }: TicketStatusBadgeProps) {
  const config = statusConfig[status];
  const sizeClasses = size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-3 py-1 text-sm';

  return (
    <span className={`inline-flex items-center rounded-full font-medium ${config.className} ${sizeClasses}`}>
      {config.label}
    </span>
  );
}
